<template>
    <div>
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span style="color: #ffffff">学员列表</span>
            </template>
            <template #left>
                <router-link to="/my">
                    <van-icon name="arrow-left" color="#ffffff"/>
                    <span style="color: #ffffff">返回</span>
                </router-link>
            </template>
            <template #right>
                <router-link to="/">
                    <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
                </router-link>
            </template>
        </van-nav-bar>

        <van-tabs v-model="tabActive" @click="onLoad(true)">
            <van-tab title="今日" name="today"/>
            <van-tab title="昨天" name="yesterday"/>
            <van-tab title="本周" name="this_week"/>
            <van-tab title="本月" name="this_month"/>
            <van-tab title="上月" name="last_month"/>
<!--            <van-tab title="不限" name="all"/>-->
        </van-tabs>
<!--        <van-search v-model="searchValue" @search="onLoad(true)" placeholder="请输入搜索关键词"/>-->

        <van-row style="line-height: 50px;margin: 0 16px;"  justify="space-between" type="flex">
            <van-col>
                总计:{{listTotal}} 已装载 {{users.length}}
            </van-col>

            <van-col>
                <van-button type="default" size="small" @click="changeSearchModel = true">查找</van-button>&nbsp;&nbsp;
                <van-button type="default" size="small" @click="changeOrderFieldModel = true">排序</van-button>
            </van-col>
        </van-row>

<!--        <van-divider :style="{margin: '6px 0' }">为你搜索到{{listTotal}}个学员</van-divider>-->

        <van-list
                v-model="loading"
                :finished="finished"
                :error.sync="error"
                :error-text="error_text"
                finished-text="没有更多了"
                @load="onLoad(false)"
        >
            <van-collapse v-model="listActive">
                <van-panel style="margin: 0 16px" v-for="user in users" :key="user.id">
                    <template #header>
                        <van-row  gutter="20" type="flex">
                            <van-col>
                                <van-image v-if="user.avatar" round width="50px" :src="user.avatar"/>


                                <van-image v-else round width="50px" :src="require('@/assets/logo.png')" />
                            </van-col>

                            <van-col>
                                <van-row>
                                    {{user.nickname}}  (ID:{{user.id}})
                                </van-row>
                                <van-row style="font-weight: 200">
                                   {{user.province}} {{user.city}}
                                </van-row>
                            </van-col>
                        </van-row>
                    </template>

                    <div style="font-weight: 100">
                        来源:{{0===user.organ_id?'搜索':'代理-'+user.organ.name}}<br>
                        关注时间:{{user.created_at}}<br>
                        上次登陆:{{user.last_login_time}}<br>
                        绑定科目:{{user.subject_name}}<br>

                        练习时长:{{user.exercise_duration}}秒<br>
                        模拟次数:{{user.exam_times}}<br>
                        最新成绩:{{user.last_exam_score}}<br>

                        <van-button v-if="user.id_card.length>0" type="info" plain size="mini" @click="toShowPeriods(user)">查看视频学习记录</van-button>
                    </div>

                </van-panel>
            </van-collapse>
        </van-list>

        <van-dialog v-model="showPeriodsModel"
                    :close-on-click-overlay="true"
                    title="视频学习记录">
            <van-row style="margin: 10px 20px">

                <van-row style="font-size: 11px">
                    姓名:{{user.name}} <br>
                    身份证：{{user.id_card}}
                </van-row>

                <van-row>
                    <div style="margin-bottom: 10px;max-height: 300px;font-size: 6px;overflow:auto;">
                        <table>
                            <tr>
                                <th>课程</th>
                                <th>学时</th>
                            </tr>
                            <tr v-for="(item, index) in periods" :key="index">
                                <td>{{item.name}}</td>
                                <td class="my-center">{{formatSeconds(item.progress)}}</td>
                            </tr>
                        </table>
                    </div>
                </van-row>



            </van-row>

        </van-dialog>

        <van-dialog v-model="changeOrderFieldModel"
                    showCancelButton
                    @confirm="onLoad(true)"
                    title="请选择排序方式">
            <van-row style="margin: 10px 20px">
                <van-radio-group v-model="order_field">
                    <van-cell-group title="">
                        <van-cell v-for="item in getOrderField()" :key="item.value" :title="item.name"
                                  clickable
                                  @click="order_field = item.value">
                            <template #right-icon>
                                <van-radio :name="item.value"/>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </van-row>
        </van-dialog>

        <van-dialog v-model="changeSearchModel"
                    showCancelButton
                    @confirm="onLoad(true)"
                    title="用户查找">
            <van-row style="margin: 10px 20px">
                <van-search v-model="searchValue" placeholder="请输入用户id或昵称"/>
            </van-row>
        </van-dialog>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                tabActive: "this_week",
                order_field:"id",
                is_organ:0,
                page: 1,
                listTotal: 0,
                listActive: [],

                loading: false,
                finished: false,
                error: false,
                error_text: "",
                searchValue: "",

                changeSearchModel:false,
                changeOrderFieldModel:false,

                users: [],
                user:{},//选择的一个人
                showPeriodsModel:false,//学时展示弹层
                periods:[],
            };
        },
        created() {
            if (undefined === this.$route.query.is_organ || "" === this.$route.query.is_organ) {
                this.is_organ = 0
            } else {
                this.is_organ = 1
            }
        },
        methods: {
            onLoad(isNew) {
                if (isNew) {
                    this.users = [];
                    this.page = 1;
                    this.finished = false;
                }
                this.loading = true;
                this.$http.get("/wechat/organ/users", {
                    params: {
                        pre_page: 5,
                        page: this.page,
                        is_organ:this.is_organ,
                        special: this.tabActive,
                        order_field:this.order_field,
                        word: this.searchValue
                    }
                }).then(res => {
                    this.loading = false;
                    console.log(res.data);
                    if (200 !== res.data.code) {
                        this.error = true
                        this.error_text = res.data.msg
                        return
                    }
                    if (!res.data.data || res.data.data.length <= 0) {
                        this.finished = true
                        return;
                    }
                    this.page++

                    this.listTotal = res.data.meta.total
                    this.users = this.users.concat(res.data.data);
                });
            },
            toShowPeriods(user){
              this.user=user
              this.periods=[]
              this.$http.get("/wechat/organ/user/"+user.id+"/periods").then(res => {
                this.periods=res.data.data;
                this.showPeriodsModel = true
              });
            },
            getOrderField(){
                return [
                    {value: "id", name: '默认'},
                    {value: "last_login_time", name: '最近登陆时间'},
                    {value: "", name: '练习时长'},
                    {value: "", name: '模拟次数'},
                    {value: "", name: '登录次数'},
                    {value: "subject_id", name: '当前科目'},
                ];
            },
            formatSeconds(value) {
                let result = parseInt(value)
                let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
                let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
                let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

                let res = '';
                if(h !== '00') res += `${h}小时`;
                if(m !== '00') res += `${m}分`;
                res += `${s}秒`;
                return res;
            }
        }
    }
</script>
